export enum CareTeamTranslations {
  ADD_PROVIDER_TEAM = 'Add provider team',
  ADD_TEAM = 'Add team',
  CANCEL = 'Cancel',
  ERROR_LOADING_CARE_TEAM = 'We encountered an error loading the provider team',
  EDIT_PROVIDER_TEAM = 'Edit provider team',
  EDIT_TEAM = 'Edit team',
  EMPTY_PROVIDER_TEAM = 'No provider team members have been added yet.',
  PROVIDER_TEAM = 'Provider team',
  NO_INQUIRY_OR_TREATMENT_EPISODE = 'This patient has no provider team.',
  SAVE_CHANGES = 'Save changes',
  SEARCH_INPUT_PLACEHOLDER = 'Search by name or role to add team members',
  TEMPORARY = 'Temporary',
  END_ASSIGNMENT = 'End assignment',
  VOID_ASSIGNMENT = 'Void assignment',
  VOID_ASSIGNMENTS = 'Void assignments',
  MARKED_TO_END = 'Marked to end',
  MARKED_TO_VOID = 'Marked to void',
  UNDO = 'Undo',
  VOID_REASON = 'Void reason',
  VOID_REASON_PLACEHOLDER = 'Select a void reason',
  VOID_ASSIGNMENT_DISCLAIMER = 'Are you sure you want to void this assignment? This should only be done if the provider never provided care to the patient.',
  VOID_ASSIGNMENT_DISCLAIMER_MULTIPLE = 'Are you sure you want to void these assignments? This should only be done if the provider never provided care to the patient.',
  VOID_ASSIGNMENT_DISABLED_TOOLTIP = 'Unavailable until a treatment episode is created',
  INQUIRY_TEXT_CONTENT = 'Dates not set',
  PENDING = 'Pending',
  REASSIGNMENT_FAILED = 'Reassignment failed',
  EDIT_REASSIGNMENT_DATE = 'Edit reassignment date',
  VOID_REASSIGNMENT = 'Void reassignment',
}
